module.exports = __webpack_public_path__ + "static/media/pic7.05330911.jpg";